// extracted by mini-css-extract-plugin
export default {"main":"Projetos_main__1zMqS"};